<!-- Main Container -->
<div class="layout-col full">
  <span style="width: 80vw"></span>

  <!-- Toolbar -->
  <elder-toolbar color="primary" class="flex-none">
    <ng-template elderToolbarColumn="left.begin">
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </ng-template>

    <ng-template elderToolbarColumn="right" [elderToolbarDefault]="true">
      <!-- Clear default language -->
    </ng-template>
  </elder-toolbar>

  <app-work-order-detail-full class="flex" [orderId]="orderId"> </app-work-order-detail-full>
</div>
